import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import aboutUs from '../views/aboutUs/index.vue'
import contact from '../views/aboutUs/contact.vue'
import newsCenter from '../views/newsCenter/index.vue'
import articleDet from '../views/articleDet/index.vue'
import product from '../views/product/index.vue'
import business from '../views/business/index.vue'
import search from '../views/search/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
    // component: () => import('../views/HomeView.vue')
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs
    // component: () => import('../views/aboutUs/index.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: contact
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: newsCenter
    // component: () => import('../views/newsCenter/index.vue')
  },
  {
    path: '/articleDet',
    name: 'articleDet',
    component: articleDet
    // component: () => import('../views/articleDet/index.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: product
  },
  {
    path: '/business',
    name: 'business',
    component: business
  },
  {
    path: '/search',
    name: 'search',
    component: search
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
 /*  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      //此处意思 即若回退页面，返回savedPosition，且页面不置顶
      console.log(savedPosition);
      return savedPosition
    } else {
      //此处意思 若页面跳转新页面，则页面置顶
      return {x: 0, y: 0, behavior: 'smooth'}
    }
  } */
})

export default router
